module.exports = __webpack_public_path__ + "static/img/Letter.c8a53c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/design/Letter.png
// module id = GQ+h
// module chunks = 0